import React from 'react'
import PropTypes from 'prop-types';
import KeyFinancialIndicatorForm from './tristan/KeyFinancialIndicatorForm';
import CustomFormIds from './customFormIds';
import BaseCaseComparisonForm from './tristan/BaseCaseComparisonForm';

const M_ManageCustomForm = (props) => {
  const {handleClose,open,customFormId,title,afterClose} = props;

  let component = null
  switch (customFormId) {
    case CustomFormIds.TRIST_KEY_FIN_IND:
      component = <KeyFinancialIndicatorForm open={open} handleClose={handleClose} title={title} afterClose={afterClose}/>
      break;
    case CustomFormIds.TRIST_BASE_COMP:
      component = <BaseCaseComparisonForm open={open} handleClose={handleClose} title={title} afterClose={afterClose}/>
      break;
    default:
      component = null;
      break;
  }

  return component;
}

M_ManageCustomForm.propTypes = {
  handleClose: PropTypes.func,
  open: PropTypes.bool,
  title :PropTypes.string,
  customFormId: PropTypes.string,
  afterClose: PropTypes.func
}

export default M_ManageCustomForm